export default __webpack_public_path__ + "c755f3f.png";